import { render, staticRenderFns } from "./step_description_complectyushie.vue?vue&type=template&id=bdbd3446&scoped=true"
import script from "./step_description_complectyushie.vue?vue&type=script&lang=js"
export * from "./step_description_complectyushie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbd3446",
  null
  
)

export default component.exports